import script from "./OrganizationCreationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationCreationPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationCreationPage.vue?vue&type=style&index=0&id=2b1c1e5c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1c1e5c"]])

export default __exports__